<app-simple-header></app-simple-header>
<div class="mastercontent">
    <router-outlet></router-outlet>
</div>